<template>
	<div class='listofsidebardeals'>
		<div class="header-container">
			<svg v-if="open" @click="open = !open" class="icon">
				<use xlink:href="#icon-arrow-down" />
			</svg>
			<svg v-else @click="open = !open" class="icon">
				<use xlink:href="#icon-arrow-collapse" />
			</svg>
			<div class='title'>
				<div>{{label}} <span v-if='count!==false'>{{count?`(${count})`:''}}</span></div>
				<span class='see_all' v-if='count || seeAll' @click='$emit("select")'>See all</span>
			</div>
		</div>
		<div class='listofsidebardeals-container' v-if='listOfDeals.length && open'>
			<Deal v-for='(deal, d) in listOfDeals'
				:key='d'
				:deal='deal'
				:link='link'
				@click='clickDealHandle'
			/>
		</div>
	</div>
</template>

<script>
import Deal from './components/Deal/Deal.vue';
export default {
	name:  'ListOfSidebarDeals',
	props: {
		label: {
			type:    String,
			default: ''
		},
		listOfDeals: {
			type:    Array,
			default: () => { return []; }
		},
		count: {
			type:    [Number, Boolean],
			default: false
		},
		link: {
			type:    String,
			default: ''
		},
		seeAll: {
			type:    Boolean,
			default: false
		}
	},
	data() {
		return {
			open: true,
		};
	},
	components: {
		Deal
	},
	methods: {
		clickDealHandle(id) {
			this.$emit('clickDeal', id);
		}
	}
};
</script>
